/**
 * SEO structured data generators (JSON-LD)
 */

const APP_NAME = 'WekaTrust';
const BASE_URL = typeof window !== 'undefined' ? window.location.origin : 'https://wekatrust.com';

export function generateOrganizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: APP_NAME,
    url: BASE_URL,
    logo: `${BASE_URL}/wekatrust.png`,
    description: 'Secure escrow platform for peer-to-peer transactions in Cameroon and Africa.',
  };
}

export function generateWebSiteSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: APP_NAME,
    url: BASE_URL,
    potentialAction: {
      '@type': 'SearchAction',
      target: { '@type': 'EntryPoint', urlTemplate: `${BASE_URL}/search?q={search_term_string}` },
      'query-input': 'required name=search_term_string',
    },
  };
}

export function generateServiceSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: `${APP_NAME} Escrow`,
    provider: { '@id': `${BASE_URL}/#organization` },
    description: 'Secure escrow for peer-to-peer transactions. 3 Taps to Trust.',
  };
}

/**
 * @param {Array<{ name: string, text: string }>} steps
 */
export function generateHowToSchema(steps) {
  return {
    '@context': 'https://schema.org',
    '@type': 'HowTo',
    name: '3 Taps to Trust',
    step: (steps || []).map((s, i) => ({
      '@type': 'HowToStep',
      position: i + 1,
      name: s.name,
      text: s.text,
    })),
  };
}

/**
 * @param {Array<{ question: string, answer: string }>} faqs
 */
export function generateFAQSchema(faqs) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: (faqs || []).map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };
}
